<template>
  <v-container>
    <v-row v-if="Object.keys(details).length == 0 && details.constructor == Object" align="center" style="height:calc(100vh - 200px);flex-direction:column" justify="center">
      <v-progress-linear
      indeterminate
      color="#F36F2E"
      height="8"
    ></v-progress-linear>
    <br>
    <h3>Fetching Data</h3>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="8">
        <!-- CUSTOMER WALLET  -->
        <wallet-card :details="details"></wallet-card>
        <br />
        <!-- TRANSACTIONS  -->
        <Transaction :transactions="trades" />
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12" md="12">
            <v-card flat class="customer-card dt-border">
              <!-- CUSTOMER INFO  -->
              <customer-info :details="details"></customer-info>
              <br /><br />
              <Activities :activities="transactions"/>
            </v-card>
          </v-col>
        </v-row>

        <!-- </v-container> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WalletCard from "../components/wallet.vue";
import Transaction from "../components/transactions.vue";
import CustomerInfo from "../components/customer-info.vue";
import Activities from "../components/activities.vue";

// =========== IMPORT SERVICE =========
import { UsersService } from '@/services';

export default {

  components: {
    WalletCard,
    Transaction,
    CustomerInfo,
    Activities
  },
  data: () => ({
    details:{},
    transactions: [],
  }),
  mounted(){
    this.getDetails()
  },
  methods:{
    async getDetails(){
      try {
        const id = {
          id:this.$route.params.id
        }
        // const data = await UsersService.viewUser({
        //   id : this.$route.params.id
        // });
        const [user, transactions, trades] = await Promise.all([
          UsersService.viewUser(id),
          // UsersService.viewUserTransaction(id),
          // UsersService.viewUsersTrades(id)
        ]);
        this.details = user;
        this.transactions = transactions;
        this.trades = trades
        // this.details = data;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-card {
  padding: 30px;
}
</style>